import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators'
import { SvgIcons } from '../../voyage-svg-icons/src/voyage-svg-icons';
import { VesselClfPopupModel } from '../../../src/models/vessel-clf-popup-model';
import { VesselPlanningModel } from '../../../src/models/vessel-planning-model';
import { WRStatus } from '../../voyage-suggested-routes/src/helper';

type Reasons<T extends string> = {
    [key in T]: string;
};

export const CLF_POPUP_VISBILITY_EVENT = 'clf-popup-visible'
export const CLF_POPUP_CANCEL_CLICKED = 'clf-popup-cancel-clicked'
export const CLF_POPUP_SUBMIT_CLICKED = 'clf-popup-submit-clicked'


const WrReasons = {
    NotSafeRoute  : 'I do not consider the route safe',
    WeatherDifferentFromPredicted: 'The weather is different from forecast',
    RouteNotFeasible: 'Vessel have technical constraints and is unable to follow the advice.',
}

const WR_REJECT_DESCRIPTION = `you are dismissing the provided weather routing advice, kindly
provide feedback for WNI and Voyage Execution team`

const WR_REJECT_TITLE = 'Reason for dismissing weather routing advice'

const SUCCES_MODAL_CONTENT = `your feedback has been submitted successfully`

const WR_REJECT_FOOTER_DESCRIPTION = `kindly update your voyage plan if needed and set it to approved
in order to inform WNI and Voyage Execution team about your intensions`

@customElement('vessel-wr-clf-popup')
export class VesselWrClfPopup extends LitElement {

    constructor(){
        super();
        this._setPopupVisibility = this._setPopupVisibility.bind(this)
        this._onSubmit = this._onSubmit.bind(this)
        this._onCancel = this._onCancel.bind(this)
    }

    connectedCallback(): void {
        super.connectedCallback()
        VesselClfPopupModel!.addEventListener(
            CLF_POPUP_VISBILITY_EVENT,
            (e: Event) => this._setPopupVisibility(e),
        )
    }

    disconnectedCallback(): void {
        super.disconnectedCallback()
        VesselClfPopupModel!.removeEventListener(
            CLF_POPUP_VISBILITY_EVENT,
            (e: Event) => this._setPopupVisibility(e),
        )
    }

    static get styles() {
        return [
            css`
                :host {
                    font-family: MaerskText;
                    z-index: 9999;
                }
                .comment {
                    font-family: 'MaerskText';
                    width: 380px;
                    height: 70px;
                    border: 1px solid #c4c4cd;
                    line-height: 20px;
                    resize: vertical;
                    border-radius: 6px;
                }
                .comment[errorComment] {
                    border-color: var(--voyage-alarm-red);
                }
                #alarm-popup .popup {
                    width: 400px;
                    max-width: 80vw;
                    height: 40vh;
                    padding: 0 24px;
                }

                #success-topContainer {
                    padding: 24px;
                    width: 392px;
                    display: grid;
                    align-items: center;
                    justify-items: start;
                    column-gap: 15px;
                    row-gap: 16px;
                    border-bottom: 1px solid var(--neutrals-grey-07);
                }
                .success-innerContainer {
                    display: flex;
                    background-color: #c5e5c2;
                    padding: 20px;
                    border-radius: 6px;
                }
                .content {
                    margin-left: 20px;
                }
                .max-width-container h2 {
                    margin-top: 0px;
                }
                .name {
                    color: var(--neutrals-grey-02, grey);
                    font-size: 16px;
                    font-family: MaerskText;
                    line-height: 20px;
                    font-weight: 400;
                    margin-top: 20px;
                    margin-bottom: 10px;
                }
                .desc {
                    color: var(--neutrals-grey-02, grey);
                    font-size: 14px;
                    font-family: MaerskText;
                    line-height: 20px;
                    margin-bottom: 24px;
                }
                .desc span {
                    text-decoration: underline;
                    cursor: pointer;
                }
                .dropdown {
                    box-sizing: border-box;
                    min-height: 41px;
                    border: 1px solid var(--neutrals-grey-06, grey);
                    border-radius: 2.5px;
                    font-family: MaerskText;
                    font-size: 14px;
                    color: var(--neutrals-grey-02, black);
                    background-color: var(--neutrals-grey-10, white);
                    text-indent: 5px;
                    width: 100%;
                    width: 394px;
                    margin-bottom: 10px;
                    border-radius: 6px;
                }

                .dropdown[disabled] {
                    background-color: var(--neutrals-grey-08, black);
                }
                .dropdown[error] {
                    border-color: #b80012;
                }
                #alarm-popup #footer {
                    display: flex;
                    justify-content: flex-end;
                    padding: 12px;
                    background: #f7f7f7;
                }

                .title {
                    margin-top: 0px;
                    font-family: MaerskText;
                }

                #alarm-popup #footer button {
                    height: 35px;
                    min-width: 80px;
                    font-size: 14px;
                    font-family: MaerskText;
                    background: none;
                    border: none;
                    outline: none;
                    cursor: pointer;
                    border-radius: 3px;
                    width: auto;
                }

                #alarm-popup #footer .do-it-later-button {
                    color: var(--neutrals-grey-02);
                    margin-right: 10px;
                    border: 1px solid var(--neutrals-grey-06, grey);
                    display: flex;
                    line-height: 28px;
                }

                #alarm-popup #footer .submit-button {
                    margin-right: 20px;
                    border-radius: 6px;
                }

                .comment-input {
                    width: 100%;
                    position: realtive;
                }

                .max-width-container {
                    width: 100%;
                }
                .center {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 100%;
                }
                .error-message {
                    color: #b80012;
                    line-height: 20px;
                    font-size: 14px;
                    font-weight: 400;
                    margin-top: -5px;
                }
                .comment-input > textarea {
                    white-space: normal;
                    padding-left: 10px;
                    font-family: MaerskText;
                }

                .mdc-dialog__content{
                    display: flex;
                    flex-direction: column;
                    height: 100%;
                    overflow-y: auto;
                    justify-content: space-between;
                }

                .modal-footer {
                    margin: -30px;
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;
                    padding-bottom: 0px;
                    height: 64px;
                    background: #f7f7f7;
                    border-bottom-left-radius: 6px;
                    border-bottom-right-radius: 6px;
                    position: absolute;
                    bottom: 30px;
                    left: 30px;
                    width: 100%;
                }
                .footer-button{
                    margin-right: 25px;
                }
                .footer {
                    text-align: end;
                    padding: 16px 24px;
                    margin: -24px;
                    margin-top: 20px;
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-end;
                    align-items: center;
                    padding-bottom: 0px;
                    gap: 12px;
                    height: 64px;
                    background: #f7f7f7;
                    border-bottom-left-radius: 6px;
                    border-bottom-right-radius: 6px;
                }
                .footer-button {
                    background-color: #ffffff;
                }

                .padding-top {
                    padding-top: 20px;
                }

                mc-modal::part(container) {
                    z-index: 9999;
                }
            `,
        ]
    }

    @property({ type: Boolean }) _shown: boolean = false
    @property({ type: String }) _planId : string = ''
    @property({ type: Boolean }) _shownSuccessPopup: boolean = false
    @property({ type: String }) _description: string = ''
    @property({ type: String }) _selectedReason: string = ''
    @property({ type: String }) private _comment: string | null = null
    @property({ type: String }) _correlationId: string = ''
    private _showError: boolean = false
    private _title : string = WR_REJECT_TITLE;


    async _setPopupVisibility(e: Event) {

        const plan = await VesselPlanningModel!.getCurrentPlan((e as CustomEvent).detail.scheduleId);
        if (!plan) {
            console.error('No plan found')
            return
        }

        const isWeatherRouteUpdate = plan?.routes.find(r => r.routeCreatedBy === 'WR' && r?.weatherRoutingInfo?.status === WRStatus.Accept);

        this._title = isWeatherRouteUpdate ? 'Reason for dismissing weather routing update' :  WR_REJECT_TITLE;

        this._shown = (e as CustomEvent).detail.show
        this._planId = (e as CustomEvent).detail.plansId
        this._correlationId = (e as CustomEvent).detail.correlationId ?? ''
    }

    render() {
        if (this._shownSuccessPopup) {
            return html`${this._renderSubmitSuccessModal()}`
        }

        return html`${this._renderReasonSubmitModal()}`
    }

    private _renderSubmitSuccessModal() {
        return html`
            <voyage-popup id="alarm-popup" ?noCloseButton = ${true} ?noHeader = ${true}
                ?shown=${this._shownSuccessPopup}>
                <div id="success-topContainer">
                    <div class="max-width-container">
                        <div class="success-innerContainer">
                            <div>
                                <span>${SvgIcons.tickMark}</span>
                            </div>
                            <div class="content">
                                <h4 class ="title">Thank you!</h4>
                                <div class="desc">${SUCCES_MODAL_CONTENT}</div>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
                    <div id="footer" slot="footer">
                         <mc-button  class="submit-button"  appearance="primary" variant="filled" @click=${() => this._shownSuccessPopup = false} >Close</mc-button>
                 </div>
            </voyage-popup>
        `
    }

    private _onCancel() {
        this._shown = false
        VesselClfPopupModel!.onCancelClicked();
    }

    private _onSubmit() {
        if (!this._selectedReason || !this._comment) {
            this._showError = true
            this.requestUpdate()
            return
        }

        VesselClfPopupModel!.createVesselClfPopupNotification(
            {
                reason: this._selectedReason,
                comment: this._comment ?? '',
                correlationId: this._correlationId,
            },
            'wr_reject',
        )
        this._shown = false
        this._shownSuccessPopup = true
        this._showError = false

        VesselClfPopupModel!.dispatchEvent(new CustomEvent(CLF_POPUP_SUBMIT_CLICKED, 
            { 
                detail: {
                    reason: this._selectedReason,
                    comment: this._comment ?? '',
                } 
            }));
    }

    private _renderReasonSubmitModal() {
        return html`<mc-modal
            heading=${this._title}
            ?open=${this._shown}
            dimension="small"
            width="450px"
            height="500px"
            backdropcloseactiondisabled
            escapecloseactiondisabled
            entercloseactiondisabled
            hiddenclose
        >
            ${this._renderModalContent()}
        </mc-modal> `
    }

    private _renderModalContent() {
        return html`
            <div>
            <div class="desc">${WR_REJECT_DESCRIPTION}</div>
            <mc-select

                    label="Reason"
                    @optionselected=${(e: Event) => this._selectedReason = (e.target as HTMLSelectElement).value}
                    ?invalid=${!this._selectedReason&& this._showError}>
                    <span slot="errormessage">Please select a reason</span>
                    ${Object.values(WrReasons).map(
                    (val) => html`
                        <mc-option .value=${val as string}>${val}</mc-option>
                    `,
            )}
                </mc-select>
            ${(!this._selectedReason && this._showError)
                ? html`<div class="error-message">Please select a reason</div>`
                : html``}

            <div class="comment-input">
                <div class="name">
                    Comment
                </div>
                <textarea
                    class="comment"
                    type="text"
                    placeholder="Write your reason or notes"
                    @input=${(e: Event) => this._comment = (e.target as HTMLTextAreaElement).value}
                ></textarea>
                ${(!this._comment && this._showError)
                ? html`<div class="error-message">
                          Please provide comment
                      </div>`
                : html``}
                <div class="desc padding-top">${WR_REJECT_FOOTER_DESCRIPTION}</div>
            </div>
            <div class="modal-footer">
                <mc-button
                    class="footer-button"
                    appearance="neutral"
                    variant="filled"
                    @click=${this._onCancel}
                    >Cancel</mc-button>
                <mc-button
                    class="footer-button"
                    focusstartanchor
                    appearance="primary"
                    variant="filled"
                    @click=${this._onSubmit}
                    >Submit</mc-button
                >
            </div>
        </div>
        `
    }
}
